"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormFieldSpinnerUp = _interopRequireDefault(require("wix-ui-icons-common/system/FormFieldSpinnerUp"));

var _FormFieldSpinnerDown = _interopRequireDefault(require("wix-ui-icons-common/system/FormFieldSpinnerDown"));

var _TickerSt = require("./Ticker.st.css");

var _InputConsumer = _interopRequireDefault(require("../InputConsumer"));

var _constants = require("./constants");

var Ticker = function Ticker(_ref) {
  var onUp = _ref.onUp,
      onDown = _ref.onDown,
      upDisabled = _ref.upDisabled,
      downDisabled = _ref.downDisabled,
      dataHook = _ref.dataHook;
  return /*#__PURE__*/_react["default"].createElement(_InputConsumer["default"], {
    consumerCompName: Ticker.displayName
  }, function (_ref2) {
    var disabled = _ref2.disabled,
        readOnly = _ref2.readOnly,
        size = _ref2.size,
        border = _ref2.border;
    var isUpDisabled = upDisabled || disabled || readOnly;
    var isDownDisabled = downDisabled || disabled || readOnly;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _TickerSt.st)(_TickerSt.classes.root, {
        size: size,
        border: border
      }),
      "data-hook": dataHook
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-hook": _constants.dataHooks.tickerUp,
      "data-disabled": isUpDisabled,
      className: (0, _TickerSt.st)(_TickerSt.classes.up, {
        disabled: isUpDisabled
      }),
      onClick: isUpDisabled ? null : onUp
    }, /*#__PURE__*/_react["default"].createElement(_FormFieldSpinnerUp["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      "data-hook": _constants.dataHooks.tickerDown,
      "data-disabled": isDownDisabled,
      className: (0, _TickerSt.st)(_TickerSt.classes.down, {
        disabled: isDownDisabled
      }),
      onClick: isDownDisabled ? null : onDown
    }, /*#__PURE__*/_react["default"].createElement(_FormFieldSpinnerDown["default"], null)));
  });
};

Ticker.displayName = 'Input.Ticker';
Ticker.propTypes = {
  onUp: _propTypes["default"].func,
  onDown: _propTypes["default"].func,
  upDisabled: _propTypes["default"].bool,
  downDisabled: _propTypes["default"].bool,
  dataHook: _propTypes["default"].string
};
var _default = Ticker;
exports["default"] = _default;